import React from 'react';
import { connect, ConnectedProps } from 'react-redux';
import { UserInfo, TcbFileItem, TcbObjInfo, MenuItemModel, GridColConfig } from '../../models/models';
import { loadingDiv } from '../../functions/componentFunctions';
import FileViewerDlg from '../Dialogs/FileViewerDlg';
import CheckBoxInputCtl from '../InputCtls/CheckBoxInputCtl';
import { mapStateToProps, mapDispatchToProps } from '../../redux/reduxActions';
import ErrorMsg from '../ErrorMsg';
import { TcbFileLoadStatusEnum, FileDisplayModeEnum, FileDialogModeEnum, PageViewTypeEnum } from '../../models/enums';
import moment from 'moment'
import { filterBy, orderBy, CompositeFilterDescriptor, SortDescriptor } from "@progress/kendo-data-query";
import { Grid, GridColumn, GridHeaderCellProps, GridCellProps, GridFilterChangeEvent, GridSortChangeEvent } from '@progress/kendo-react-grid';
import { Menu, MenuSelectEvent } from '@progress/kendo-react-layout';
import { UploadFileInfo } from '@progress/kendo-react-upload';
import { downloadFileItem, downloadBlob } from '../../functions/componentFunctions';
import './TcbObjAttachments.css';

const connector = connect(mapStateToProps, mapDispatchToProps);

const initialSort: Array<SortDescriptor> = [
    { field: "lastChangedOn", dir: "desc" },
  ];

type PropsFromRedux = ConnectedProps<typeof connector>;


type TcbObjAttachmentsProps = PropsFromRedux & {
    tcbObj: TcbObjInfo;
    fileMode: FileDisplayModeEnum;
    canEdit: boolean;
    stateToLoad?: TcbObjAttachmentsState;
    onSaveState?: (e: TcbObjAttachmentsState) => void;
}

interface TcbObjAttachmentsState {
    searchInProg: boolean;

    tcbObjFiles: TcbFileItem[];
    filesFetched: boolean;
    fetchError: boolean;
    fetchErrorMsg: string;

    gridColumns: GridColConfig[];
    gridSelectAllVal: boolean;

    fileDialogMode: FileDialogModeEnum;
    showFileDlg: boolean;
    fileDialogFile?: TcbFileItem;
    fileDialogFiles?: TcbFileItem[];

    addDlgUploadFiles: UploadFileInfo[];
    addDlgMessage: string;

    sort: Array<SortDescriptor>;
    filter: CompositeFilterDescriptor;

}

class TcbObjAttachments extends React.Component<TcbObjAttachmentsProps, TcbObjAttachmentsState> {
    constructor(props: TcbObjAttachmentsProps) {
        super(props);

        if (this.props.fileMode === FileDisplayModeEnum.Attachments) {
            this._fileModeStr = "Attachment";
        } else {
            this._fileModeStr = "Image";
        }

        if (this.props.stateToLoad) {
            this.state = {
                ...this.props.stateToLoad,
                gridColumns: this.buildGridCols(),
                filter: this.props.stateToLoad.filter ?? { logic: 'and', filters: [] },
            };
        } else {

            this.state = {
                searchInProg: true,
                tcbObjFiles: [],
                filesFetched: false,
                fetchError: false,
                fetchErrorMsg: '',
                gridColumns: this.buildGridCols(),
                gridSelectAllVal: false,
                fileDialogMode: FileDialogModeEnum.Closed,
                addDlgUploadFiles: [],
                addDlgMessage: '',
                showFileDlg: false,
                sort: initialSort,
                filter: { logic: 'and', filters: [] },
            };
        }


    }

    private _fileModeStr: string = "";

    componentDidMount() {
        //if (!this.state.filesFetched) {
            this.getTcbObjFiles();
        //}
    }

    componentDidUpdate(prevProps: TcbObjAttachmentsProps) {
    }

    buildGridCols = () => {
        let retVal: GridColConfig[] = [];

        retVal.push({ name: 'Select', title: '', field: 'select', width: 30, resizable: false, canSort: false, canFilter: false  });
        retVal.push({ name: 'Context', title: '', field: 'context', width: 30, resizable: false, canSort: false, canFilter: false  });

        if (this.props.fileMode === FileDisplayModeEnum.Images) {
            retVal.push({ name: 'Thumb', title: 'Preview', field: 'thumbnailStr', width: 200, resizable: true, canSort: false, canFilter: false  });
        } else {
            retVal.push({ name: 'Filename', title: 'Filename', field: 'fileName', width: 200, resizable: true, canSort: false, canFilter: true  });
        }

        retVal.push({ name: 'FileDesc', title: 'Description', field: 'fileDesc', width: 150, resizable: true, canSort: false, canFilter: true  });
        retVal.push({ name: 'RefNo', title: 'Ref No', field: 'fileRefNo', width: 100, resizable: true, canSort: false, canFilter: true  });
        retVal.push({ name: 'DocType', title: 'Doc Type', field: 'documentTypeDesc', width: 100, resizable: true, canSort: false, canFilter: true  });
        retVal.push({ name: 'ImageSrcDesc', title: 'Source', field: 'fileSrcDesc', width: 150, resizable: true, canSort: false, canFilter: true  });

        retVal.push({ name: 'LastChangedBy', title: 'Changed By', field: 'lastChangedBy', width: 100, resizable: true, canSort: false, canFilter: true  });
        retVal.push({ name: 'LastChangedOn', title: 'Changed On', field: 'lastChangedOn', width: 150, resizable: true, canSort: false, canFilter: false  });

        return retVal;
    }

    getTcbObjFiles = () => {
        this.setState({ tcbObjFiles: [], searchInProg: true });

        let url = this.props.userInf.currProject.apiUrl + '/api/details/GetTcbObjFiles';

        let body = {
            tcbObj: this.props.tcbObj,
            type: this.props.fileMode
        }

        fetch(url, { method: 'POST', body: JSON.stringify(body), headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + this.props.userInf.token } })
            .then(resp => resp.json())
            .then(res => {
                switch (res.callStatus) {
                    case "OK":
                        let img: TcbFileItem[] = res.results;
                        img.forEach(y => { y.fileLoadStatus = TcbFileLoadStatusEnum.NotLoaded; y.selected = false; });

                        this.setState({
                            tcbObjFiles: img,
                            filesFetched: true,
                            searchInProg: false
                        }, () => { if (this.props.onSaveState) this.props.onSaveState(this.state) });
                        break;
                    case "UNAUTH":
                        let uInf: UserInfo = { ...this.props.userInf, isAuthorised: false };
                        this.props.updateUserInfo(uInf);
                        this.setState({ searchInProg: false });
                        break;

                    default:
                        this.setState({
                            searchInProg: false,
                            fetchError: true,
                            fetchErrorMsg: res.callStatusMessage
                        });
                }
            })
            .catch(err => {
                this.setState({
                    searchInProg: false,
                    fetchError: true,
                    fetchErrorMsg: 'Error fetching Item Details - ' + err.toString()
                });
            });

    }


    selectedAllCellChanged = (selectVal: boolean) => {
        let fils = this.state.tcbObjFiles;
        fils.forEach(x => { x.selected = selectVal });
        this.setState({ tcbObjFiles: fils });
    }

    selectedCellChanged = (selectVal: boolean, fi: TcbFileItem) => {
        let fils = this.state.tcbObjFiles;
        let selAll = this.state.gridSelectAllVal;

        let fil = fils.find(x => x.fileId === fi.fileId);
        if (fil) {
            fil.selected = selectVal;

            if (fils.some(x => !x.selected))
                selAll = false;
            else
                selAll = true;

            this.setState({ tcbObjFiles: fils, gridSelectAllVal: selAll });
        }
    }



    contextMenuClick = (m: MenuSelectEvent, e: TcbFileItem) => {
        switch (m.item['action']) {
            case "Download":
                if (this.props.pageInf.pageViewMode === PageViewTypeEnum.Browser)
                    this.downloadFileCheck(e);
                else
                    this.setState({ showFileDlg: true, fileDialogMode: FileDialogModeEnum.View, fileDialogFile: e });
                break;

            case "DownloadSelected":
                if (this.props.pageInf.pageViewMode === PageViewTypeEnum.Browser) {
                    let fils = this.state.tcbObjFiles.filter(x => x.selected);
                    fils.forEach(x => {
                        this.downloadFileCheck(x);
                    });
                }
                break;

            case "View":
                this.setState({ showFileDlg: true, fileDialogMode: FileDialogModeEnum.View, fileDialogFile: e });
                break;

            case "Edit":
                this.setState({ showFileDlg: true, fileDialogMode: FileDialogModeEnum.Edit, fileDialogFile: e });
                break;

            case "Delete":
                this.setState({ showFileDlg: true, fileDialogMode: FileDialogModeEnum.Delete, fileDialogFile: e });
                break;
        }
    }

    viewFileClick = (f: TcbFileItem) => {
        this.setState({ showFileDlg: true, fileDialogMode: FileDialogModeEnum.View, fileDialogFile: f });
    }

    addNewFileClick = () => {
        this.setState({ showFileDlg: true, fileDialogMode: FileDialogModeEnum.Add });
    }


    downloadFileCheck = (f: TcbFileItem) => {
        if (f.fileDataStr)
            downloadFileItem(f);
        else {
            f.fileLoadStatus = TcbFileLoadStatusEnum.InProgress;
            this.setState({ tcbObjFiles: this.state.tcbObjFiles });
            // Prefer binary bytes endpoint
            // reset per-file progress to indeterminate to show spinner immediately
            f.attachmentProgress = -1;
            this.setState({ tcbObjFiles: this.state.tcbObjFiles });
            this.downloadFileBytes(f);
        }


    }

    // Fetch bytes from GetTcbFileBytes endpoint and download using Blob.
    // The server returns a WebServiceStreamResponse wrapper. It may return raw bytes
    // in the response body or JSON containing stringResponse (base64). We try to
    // handle both cases: if response is JSON wrapper, use stringResponse; else if
    // binary, use arrayBuffer.
    downloadFileBytes = (f: TcbFileItem) => {
        const url = this.props.userInf.currProject.apiUrl + '/api/file/GetTcbFileBytes';
        const body = { fileId: f.fileId };

        return fetch(url, { method: 'POST', body: JSON.stringify(body), headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + this.props.userInf.token } })
            .then(async (resp) => {
                if (!resp.ok) {
                    const j = await resp.json().catch(() => null);
                    if (j && j.callStatus === 'UNAUTH') {
                        const uInf: UserInfo = { ...this.props.userInf, isAuthorised: false };
                        this.props.updateUserInfo(uInf);
                    }
                    throw new Error(resp.statusText || 'Download failed');
                }

                const contentType = resp.headers.get('Content-Type') || '';
                const ct = contentType.toLowerCase();
                if (ct.includes('application/json')) {
                    const j = await resp.json();
                    if (j && j.callStatus === 'OK' && j.stringResponse) {
                        f.fileDataStr = j.stringResponse;
                        f.fileLoadStatus = TcbFileLoadStatusEnum.OK;
                        downloadFileItem(f);
                        this.setState({ tcbObjFiles: this.state.tcbObjFiles }, () => { if (this.props.onSaveState) this.props.onSaveState(this.state) });
                        return;
                    } else if (j && j.callStatus === 'UNAUTH') {
                        const uInf: UserInfo = { ...this.props.userInf, isAuthorised: false };
                        this.props.updateUserInfo(uInf);
                        return;
                    } else {
                        throw new Error(j && j.callStatusMessage ? j.callStatusMessage : 'Unknown server response');
                    }
                }

                // Try to stream response body for progress
                const cd = resp.headers.get('Content-Disposition');
                let fileName = f.fileName || 'download';
                if (cd) {
                    const match = /filename="?([^";]+)"?/.exec(cd);
                    if (match && match[1]) fileName = match[1];
                }

                const contentLengthHeader = resp.headers.get('Content-Length');
                const total = contentLengthHeader ? parseInt(contentLengthHeader, 10) : NaN;

                if (resp.body && resp.body.getReader) {
                    const reader = resp.body.getReader();
                    const chunks: Uint8Array[] = [];
                    let received = 0;

                    // set file progress to 0 or -1 (indeterminate)
                    f.attachmentProgress = total ? 0 : -1;
                    this.setState({ tcbObjFiles: this.state.tcbObjFiles });

                    while (true) {
                        const { done, value } = await reader.read();
                        if (done) break;
                        if (value) {
                            chunks.push(value);
                            received += value.length;
                            if (total) {
                                f.attachmentProgress = Math.min(100, Math.round((received / total) * 100));
                                this.setState({ tcbObjFiles: this.state.tcbObjFiles });
                            }
                        }
                    }

                    const totalLen = chunks.reduce((s, c) => s + c.length, 0);
                    const combined = new Uint8Array(totalLen);
                    let pos = 0;
                    for (const ch of chunks) {
                        combined.set(ch, pos);
                        pos += ch.length;
                    }

                    const blob = new Blob([combined], { type: resp.headers.get('Content-Type') || 'application/octet-stream' });
                    f.fileLoadStatus = TcbFileLoadStatusEnum.OK;
                    f.attachmentProgress = 100;
                    downloadBlob(blob, fileName);
                    this.setState({ tcbObjFiles: this.state.tcbObjFiles }, () => { if (this.props.onSaveState) this.props.onSaveState(this.state) });
                    return;
                } else {
                    const arr = await resp.arrayBuffer();
                    const blob = new Blob([arr], { type: resp.headers.get('Content-Type') || 'application/octet-stream' });
                    f.fileLoadStatus = TcbFileLoadStatusEnum.OK;
                    f.attachmentProgress = 100;
                    downloadBlob(blob, fileName);
                    this.setState({ tcbObjFiles: this.state.tcbObjFiles }, () => { if (this.props.onSaveState) this.props.onSaveState(this.state) });
                    return;
                }
            })
            .catch(err => {
                f.fileLoadStatus = TcbFileLoadStatusEnum.Error;
                f.fileLoadErrorMsg = err.toString();
                f.attachmentProgress = 0;
                this.setState({ tcbObjFiles: this.state.tcbObjFiles });
            });
    }

    errorClose = () => {
        this.setState({ fetchError: false, fetchErrorMsg: '' });
    }


    dlgClose = () => {
        this.setState({ showFileDlg: false });
    }

    dlgAdd = (e: TcbFileItem) => {
        let fls = this.state.tcbObjFiles;
        fls.push(e);
        this.setState({ tcbObjFiles: fls });
    }

    dlgUpdate = (e: TcbFileItem) => {
        let fls = this.state.tcbObjFiles;
        let fl = fls.find(x => x.fileId === e.fileId);
        if (fl) {
            fl.fileName = e.fileName;
            fl.fileDesc = e.fileDesc;
            fl.fileRefNo = e.fileRefNo;
            fl.documentTypeId = e.documentTypeId;
            fl.documentTypeDesc = e.documentTypeDesc;
            fl.lastChangedBy = e.lastChangedBy;
            fl.lastChangedOn = e.lastChangedOn;

            this.setState({ tcbObjFiles: fls });
        }
    }

    dlgDelete = (e: TcbFileItem[]) => {
        let fls = this.state.tcbObjFiles;
        e.forEach(f => {
            fls = fls.filter(x => x.fileId !== f.fileId);
        });
        this.setState({ tcbObjFiles: fls });
    }


    renderHeaderCell = (n: React.ReactNode, e: GridHeaderCellProps) => {
        switch (e.field) {
            case "select":
                return (<div className="tcbObjAttHdrDiv">
                    <CheckBoxInputCtl key="0" value={this.state.gridSelectAllVal} onUpdate={(e) => { if (e !== null) this.selectedAllCellChanged(e) }} />
                </div>)

            case "context":
                if (this.props.canEdit) {
                    return (<div className="tcbObjAttHdrDiv">
                        <span className="k-icon k-font-icon k-i-plus-outline addNewSpan" onClick={() => this.addNewFileClick()} title="Add New" />
                    </div>)
                } else {
                    return e.title;
                }

            default:
                //return (e.title);

                return (
                    <a className="k-link" onClick={e.onClick}>
                      <span
                      >
                        {e.title}
                      </span>
                      {e.children} 
                    </a>
                  );

        }
    }

    renderDataCell = (e: any, p: GridCellProps) => {
        let fi: TcbFileItem = p.dataItem;

        switch (p.field) {
            case "select":
                return (<td><CheckBoxInputCtl key={fi.fileId} value={fi.selected} onUpdate={(e) => { if (e != null) this.selectedCellChanged(e, fi) }} /></td>)


            case "context":
                let itemMenuItms: MenuItemModel[] = [];
                let cxtMenu: MenuItemModel = { items: [], linkRender: () => { return <span className="k-icon k-font-icon k-i-more-vertical" /> } };
                itemMenuItms.push(cxtMenu);
                if (this.state.tcbObjFiles.filter(x => x.selected).length <= 1) {
                    cxtMenu.items.push({ text: 'Actions for: ' + fi.fileName, action: 'Header', cssClass: 'menuTitle', disabled: true, items: [] });
                    cxtMenu.items.push({ text: 'View ', action: 'View', icon: 'zoom', cssClass: 'menuItem', disabled: false, items: [] });
                    cxtMenu.items.push({ text: 'Download ', action: 'Download', icon: 'download', cssClass: 'menuItem', disabled: false, items: [] });
                    cxtMenu.items.push({ text: '', action: 'Separator', cssClass: 'separator', disabled: true, items: [] });
                    if (fi.canEdit) {
                        cxtMenu.items.push({ text: 'Edit', action: 'Edit', icon: 'edit', cssClass: 'menuItem', disabled: false, items: [] });
                    }
                    if (fi.canDelete) {
                        cxtMenu.items.push({ text: 'Delete', action: 'Delete', icon: 'delete', cssClass: 'menuItem', disabled: false, items: [] });
                    }
                } else {
                    cxtMenu.items.push({ text: 'Actions for ALL selected items', action: 'Header', cssClass: 'menuTitle', disabled: true, items: [] });
                    cxtMenu.items.push({ text: 'Download selected', action: 'DownloadSelected', icon: 'download', cssClass: 'menuItem', disabled: false, items: [] });
                    //cxtMenu.items.push({ text: 'Delete selected', action: 'DeleteSelected', icon: 'delete', cssClass: 'menuItem', disabled: false, items: [] });
                }
                return (<td><Menu className="tcbObjAttMenu" items={itemMenuItms} openOnClick={true} vertical={true} onSelect={(m) => this.contextMenuClick(m, fi)} /></td>);


            case "fileName":
                {
                    const prog = fi.attachmentProgress;
                    const inProg = fi.fileLoadStatus === TcbFileLoadStatusEnum.InProgress;

                    // Show spinner when indeterminate or just started; show percent bar when numeric progress available
                    let progressEl: JSX.Element | null = null;
                    if (inProg && (!isFinite(prog) || prog <= 0 || prog === -1)) {
                        progressEl = (<div style={{ display: 'flex', alignItems: 'center', gap: 6 }}><span className="k-icon k-font-icon k-i-loading" /> <span style={{ fontSize: 12, color: '#666' }}>Downloading...</span></div>);
                    } else if (typeof prog === 'number' && isFinite(prog) && prog > 0 && prog < 100) {
                        const pct = Math.min(100, Math.max(0, Math.round(prog)));
                        progressEl = (
                            <div className="inlineProgress">
                                <div className="inlineProgressBarOuter"><div className="inlineProgressBarInner" style={{ width: pct + '%' }} /></div>
                                <div className="inlineProgressPct">{pct}%</div>
                            </div>
                        );
                    }

                    return (
                        <td>
                            <div className="fileNameWithProgress">
                                <div className='fileNameLine'><span className='fileNameSpan' onClick={() => this.viewFileClick(fi)} title={fi.fileName}>{fi.fileName}</span></div>
                                <div className='fileProgressLine'>{progressEl}</div>
                            </div>
                        </td>
                    );
                }

            case "thumbnailStr":
                if (fi.thumbnailStr && fi.thumbnailStr.length > 0) {
                    let imgStr = 'data:image/jpeg;base64,' + fi.thumbnailStr;
                    return (
                        <td onClick={() => this.viewFileClick(fi)}>
                            <img src={imgStr} alt={fi.fileName} className="imgPreviewImg" />
                        </td>
                    );
                } else {
                    return (<td>Thumbnail Unavailable</td>)
                }



            case "lastChangedOn":
                let dateStr: string = "";
                if (fi.lastChangedOn) {
                    dateStr = moment(fi.lastChangedOn).format("DD-MMM-YYYY hh:mm A");
                }
                return (<td>{dateStr}</td>)

        }
        return e;   //All others render normally
    }

    setSort(e: Array<SortDescriptor>) {
        this.setState({ sort: e });
    }

    setFilter = (e: GridFilterChangeEvent) => {
        this.setState({ filter: e.filter ?? { logic: 'and', filters: [] } });
    }

    render() {
        if (this.state.fetchError) {
            return (<ErrorMsg message={this.state.fetchErrorMsg} onClose={this.errorClose} />);
        }
        if (this.state.searchInProg) {
            return loadingDiv();
        }

        let sort = this.state.sort;
        let tcbObjFiles = filterBy(this.state.tcbObjFiles, this.state.filter);

        // Columns without a fixed width share spare space; retain the grid's overall minimum width.
        const flexFields = ['fileName', 'fileDesc', 'documentTypeDesc', 'fileSrcDesc', 'fileRefNo'];
        const minTableWidth = this.state.gridColumns.reduce((tot, c) => tot + c.width, 0);

        return (<div id="tcbObjAttOuterDiv">
            <Grid
                className="tcbObjAttachmentsGrid"
                style={{ '--tcbObjAttMinWidth': minTableWidth + 'px' } as React.CSSProperties}
                data={orderBy(tcbObjFiles,sort)}
                headerCellRender={this.renderHeaderCell}
                cellRender={this.renderDataCell}
                resizable={true}
                sortable={true}
                filterable={true}
                filter={this.state.filter}
                onFilterChange={this.setFilter}
                sort={sort}
                onSortChange={(e: GridSortChangeEvent) => this.setSort(e.sort)
                }
            >
                {
                    this.state.gridColumns.map((c) => {
                        return (<GridColumn key={c.field} field={c.field} width={flexFields.includes(c.field) ? undefined : c.width} title={c.title} resizable={c.resizable} sortable={true} filterable={c.canFilter} filter="text" />);
                    })
                }
            </Grid>
            {this.state.showFileDlg &&
                <FileViewerDlg dialogMode={this.state.fileDialogMode} display={this.props.fileMode} tcbObj={this.props.tcbObj}
                    file={this.state.fileDialogFile}
                    fileList={this.state.fileDialogFiles}
                    onAdd={this.dlgAdd}
                    onUpdate={this.dlgUpdate}
                    onDelete={this.dlgDelete}
                    onClose={this.dlgClose} />
            }
        </div>);

    }

}

export default connector(TcbObjAttachments);